import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { DashboardTemplate } from 'themes/modules/dashboard/pages';
import { DashboardViewStore } from 'modules/dashboard/stores';

@setCurrentView(rootStore => new DashboardViewStore(rootStore), 'dashboardViewStore')
@observer
class Dashboard extends React.Component {
	componentWillUnmount() {
		if (this.props.dashboardViewStore && this.props.dashboardViewStore.destroy) {
			this.props.dashboardViewStore.destroy();
		}
	}

	render() {
		return <DashboardTemplate {...this.props} viewStore={this.props.dashboardViewStore} />;
	}
}

export default Dashboard;
